// Generated by CoffeeScript 1.12.7

/**
Converts a Date object to UTC

@method toUTC
@return {Boolean}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/to_utc',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.toUTC = factory();
  }
})(this, function() {
  var toUTC;
  return toUTC = function(date) {
    if (!date) {
      date = new Date;
    }
    if (date.toString() !== 'Invalid Date') {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    }
  };
});

